// extracted by mini-css-extract-plugin
export var header = "TextItemList-module--header--ArTxy";
export var list = "TextItemList-module--list--kXQ56";